<template>
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="M4 3H20V21L12 16.5L4 21Z"></path>
    </svg>
</template>
